import { Icon } from '@blueprintjs/core';
import styled from 'styled-components';

export const RatingStar = styled(Icon)`
  flex-grow: 1;
  cursor: pointer;

  transition: 200ms ease;

  &:hover {
    transform: scale(1.3) rotate(-15deg) !important;
  }

  display: flex;
  justify-content: center;

  user-select: none;
  -webkit-tap-highlight-color: transparent;
`;
